export const hasRole = (
  role: string | undefined,
  roles: readonly string[],
): boolean => role != null && roles.includes(role);
